export default __webpack_public_path__ + "static/media/pen.ace9fcb6.svg";